import { gql } from '@apollo/client/core';

import { UseEventSearchFragment } from './clip-events';

const IntrusionEventRelationFragment = gql`
  fragment IntrusionEventRelationFragment on vEvents {
    partitionID
    zoneID
    partition {
      id
      name
    }
    zone {
      id
      name
    }
    start {
      id
      partitionID
      zoneID
    }
    end {
      id
      partitionID
      zoneID
    }
  }
`;

export const GQL_SEARCH_INTRUSION_V_EVENTS = gql`
  query GQL_SEARCH_INTRUSION_V_EVENTS(
    $where: vEvents_bool_exp!,
    $limit: Int!,
    $order_by: [vEvents_order_by!]!
  ) {
    vEvents(
      where: $where,
      limit: $limit,
      order_by: $order_by,
    ) {
      ...UseEventSearchFragment
      ...IntrusionEventRelationFragment
    }
  }
  ${UseEventSearchFragment}
  ${IntrusionEventRelationFragment}
`;

/** Resolves partition names for live-pushed events, which only carry partitionID. */
export const GQL_GET_INTRUSION_PARTITIONS_BY_IDS = gql`
  query GQL_GET_INTRUSION_PARTITIONS_BY_IDS($ids: [String!]!) {
    IntrusionPartition(where: { id: { _in: $ids } }) {
      id
      name
    }
  }
`;

/** Resolves zone names for live-pushed events, which only carry zoneID. */
export const GQL_GET_INTRUSION_ZONES_BY_IDS = gql`
  query GQL_GET_INTRUSION_ZONES_BY_IDS($ids: [String!]!) {
    IntrusionZone(where: { id: { _in: $ids } }) {
      id
      name
    }
  }
`;
